import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
    withCredentials: true
});

export class YappyFetchAPI {

    static async newYappyQr(data, token) {
        const res = await server(`/yappy`, {
            method: "post",
            data: data,
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

    static async getYappyTransaction(yappy_transaction_id, token) {
        const res = await server(`/yappy?yappy_transaction_id=${yappy_transaction_id}`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

    
    //Function to create a new yappy btn transaction
    static async newYappyBtnOrder(data, token) {
        const res = await server(`/btn/yappy`, {
            method: "post",
            data: data,
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

}